import {exists} from 'shared/utils/custom-utils';

export interface Citation {
    value: string;
}

export interface CitationCitacePro extends Citation {
    redirectUrlPath: string;
    redirectUrlParameters: Record<string, any[]>
}

export function isCitationCitacePro(citation: Citation | CitationCitacePro): citation is CitationCitacePro {
    return 'redirectUrlPath' in citation
        && 'redirectUrlParameters' in citation
        && exists(citation.redirectUrlPath)
        && exists(citation.redirectUrlParameters);
}